import customAxios from "../../customAxios";
import { DISAPPROVE_PARENT_TRANSACTION } from "../../routes";

type Props = {
  transactionId?: string;
};

const disapproveparentTransaction = async (props: Props) => {
  var thisUrl = DISAPPROVE_PARENT_TRANSACTION + "/" + props.transactionId;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ DISAPPROVE_PARENT_TRANSACTION: error });
  }
};

export default disapproveparentTransaction;
